export default "__VITE_ASSET__DqIiOHoH__"